import * as React from "react";
import Modal from "react-bootstrap/Modal";
import {
  requestFolioStyleSDialog,
  requestFolioModalstyledDialog,
} from "./RequestFolioModal.module.scss";

export const StyledDialog: React.FC<any> = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      dialogClassName={requestFolioModalstyledDialog}
      className={requestFolioStyleSDialog}
      centered
      scrollable={true}
      id={"request-folio-modal"}
      aria-labelledby={props.ariaLabelledby}
      aria-label={props.ariaLabel}
      aria-describedby={props.ariaDescribedby}
    >
      {props.children}
    </Modal>
  );
};
